var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('van-empty',{attrs:{"image":"network","description":"404, 找不到页面"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }